var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import classnames from 'classnames';
import { Spinner } from '../Spinner';
import { Card } from '../Card';
export const Mask = (_a) => {
    var { active = true, borderRadius = 0, children, className, content } = _a, props = __rest(_a, ["active", "borderRadius", "children", "className", "content"]);
    const MaskClasses = classnames('Mask', className, {
        'Mask--active': active,
    });
    const MaskOverlayClasses = classnames('Mask__overlay', {
        'border-radius-1': borderRadius === 1,
        'border-radius-2': borderRadius === 2,
    });
    return (React.createElement("div", Object.assign({ className: MaskClasses, "data-anvil-component": "Mask" }, props),
        active && (React.createElement("div", { className: MaskOverlayClasses },
            React.createElement("div", { className: "Mask__backdrop" }),
            content ? (React.createElement(Card, { className: "Mask__card" }, content)) : (React.createElement(Spinner, { className: "Mask__spinner", container: true })))),
        children));
};
//# sourceMappingURL=Mask.js.map